import { store } from "../store";
import { clearSession } from "../store/sessionSlice";
import { getIdentityToken } from "./GetIdentityToken";

const getAuth = () => {
  const state = store.getState();
  const sessionToken = state.session.sessionToken || localStorage.getItem("sessionToken");
  const sessionId = state.session.sessionId || localStorage.getItem("sessionId");

  return { sessionToken, sessionId };
}

export const fetchRequest = async ({ method, path, data, isFormData }) => {
  try {
    const { sessionToken, sessionId } = getAuth();
    const identityToken = await getIdentityToken();

    let url = `${process.env.REACT_APP_API_URL}/api/v1/${path}`;
    const m = String(method || "GET").toUpperCase();

    const headers = {
      Accept: "application/json",
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(sessionToken ? { "X-Session-Token": sessionToken } : {}),
      ...(sessionId ? { "x-session-id": sessionId } : {}),
      ...(identityToken ? { Authorization: `Bearer ${identityToken}` } : {}),
    };

    const options = { method: m, headers };
    if (data != null && m !== "GET" && m !== "HEAD") {
      options.body = data;
    }

    const response = await fetch(url, options);
    const { status, ok } = response;

    if (status === 401) {
      store.dispatch(clearSession());
      if (window.location.pathname !== "/") window.location.href = "/";
      throw new Error("Unauthorized");
    }

    const result = await parseResponseBody(response);

    if (!ok) {
      const msg = getErrorMessage(result, status);
      const err = new Error(msg);
      err.status = status;
      err.result = result;
      throw err;
    }

    return { ok: true, status, result: result.data };
  } catch (error) {
    throw normalizeError(error);
  }
};

async function parseResponseBody(response) {
  const { status, headers } = response;
  const contentType = headers.get("content-type") || "";

  if (status === 204 || status === 205) return null;
  if (contentType.includes("application/octet-stream")) return await response.blob();
  
  const text = await response.text();
  if (contentType.includes("application/json")) {
    return text ? JSON.parse(text) : null;
  }
  return text;
}

function getErrorMessage(result, status) {
  if (result && typeof result === "object") {
    const firstError = result.errors?.[0];
    if (firstError?.message) return firstError.message;

    const detail = result.detail || result.message || result.error;
    if (detail) return detail;
  }
  return (typeof result === "string" && result) || `Request failed (${status})`;
}

function normalizeError(error) {
  const result = error?.result || error?.response?.data || { message: error.message };
  
  const firstError = result?.errors?.[0];

  const message =
    firstError?.message ||
    result?.detail ||
    result?.message ||
    error?.message ||
    "Request failed";

  const normalized = new Error(message);
  normalized.status = error?.status || error?.response?.status || 500;
  normalized.result = result;

  // Request-level extras
  normalized.detail   = firstError?.message ?? null;
  normalized.suggestion = firstError?.suggestion ?? null;
  normalized.field    = firstError?.field ?? null;

  // Job-level extras (kalau ada)
  normalized.grpcCode    = firstError?.grpcCode ?? null;
  normalized.grpcStatus  = firstError?.grpcStatus ?? null;
  normalized.retryable   = firstError?.retryable ?? null;

  return normalized;
}
 
 